import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-icustomer-type-wise-discount-product-price-edit-dialog-box',
  templateUrl: './icustomer-type-wise-discount-product-price-edit-dialog-box.component.html',
  styleUrls: ['./icustomer-type-wise-discount-product-price-edit-dialog-box.component.scss']
})
export class IcustomerTypeWiseDiscountProductPriceEditDialogBoxComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<IcustomerTypeWiseDiscountProductPriceEditDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private http: HttpService, private global: GlobalService) { 
      console.log(data);
    }


  updateDiscountPrice(discount_price) {
    const discount_price_data = {
      product_id: this.data['product_id'],
      customer_type_id: this.data['customer_type_id'],
      discount_price: discount_price,
    };
    this.http.saveOrUpdateIcustomerTypeWiseDiscount(discount_price_data).subscribe((res_data) => {
      console.log(res_data);
      this.global.showSnakeBar('Discount price updated successfully!');
      this.closeComponent(discount_price_data);
    }, (error) => {
      console.log(error);
    });
  }

  closeComponent(data: any) {
    this.dialogRef.close(data);
  }


  ngOnInit() {
  }

}

interface DialogData {
  product_id: number;
  icustomer_type_id: number;
  icustomer_type_name: string;
  discount_price: number;
}
